<template>
  <div id="esg-lca-emission-monitoring-by-raw-material">
    <b-container fluid>
      <lca-detail-header lca="원료 획득"
                         :total="total"
                         :total-per-production="totalPerProduction"
                         :rank="rank"/>
      <b-row>
        <b-col>
          <raw-material-detail :product="product"
                               :year="year"
                               @totalCalculated="onTotalCalculated"/>
        </b-col>
      </b-row>
      <b class="content-title mt-5">원료별 배출량 비율</b>
      <product-lca-by-material ref="chart"
                               :product="product"
                               :year="year"/>
    </b-container>
  </div>
</template>
<script>
import ProductLcaByMaterial from '../charts2/ProductLcaByMaterial.vue'
import RawMaterialDetail from "@/components/esg/3. Monitoring/tables/RawMaterialDetail.vue";
import LcaDetailHeader from "@/components/esg/3. Monitoring/3.2. LCA 배출량 관리/3.2.1. 제품별/LcaDetailHeader.vue";

export default {
  props: {
    year: {
      type: Number
    },
    product: {
      type: Object,
    },
  },
  components: {
    LcaDetailHeader,
    RawMaterialDetail,
    ProductLcaByMaterial,
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchRanks()
      }
    },
    year: {
      immediate: true,
      handler() {
        this.fetchRanks()
      }
    }
  },
  computed: {
    lca() {
      return this.$store.getters['ghg/lifeCycleStages'];
    },
    formattedRank() {
      if (!this.rank || !this.rank.rank || !this.rank.count) return null
      return `${this.rank.rank} / ${this.rank.count}`
    }
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchRanks() {
      if (!this.product || !this.product.productFamilyCode || !this.product.productCode || !this.product.name) return;
      if (!this.year) return;

      try {
        this.loading = true;

        let args = [{
          years: [this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode],
          categories: [this.lca[0].value]
        }];

        let data = new FormData()
        data.append('path', 'esg/lca/rank/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, return
        if (!response.data.data) {
          this.rank = { rank: null, count: null }
          return
        }

        // Parse JSON data
        this.rank = JSON.parse(response.data.data)[0].data[0];
      } catch (error) {
        await this.showError(error)
      }
    },
    onTotalCalculated(total, totalPerProduction) {
      this.total = total;
      this.totalPerProduction = totalPerProduction;
    }
  },
  data() {
    return {
      total: 0,
      totalPerProduction: 0,
      rank: { rank: 0, count: 0 }
    }
  },
}
</script>